var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeInsuranceAudit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#lifeInsuranceAuditSvg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 37.8c-.29.13-.54.2-.75.2-.22 0-.48-.07-.78-.2a5.43 5.43 0 0 1-.81-.44 49.48 49.48 0 0 1-7.63-5.62 25.5 25.5 0 0 1-5-6.06A12.6 12.6 0 0 1 8 19.38c0-1.39.23-2.65.7-3.8A8.85 8.85 0 0 1 17.1 10c1.59.01 2.96.39 4.1 1.14a8.53 8.53 0 0 1 2.8 2.95 8.4 8.4 0 0 1 2.77-2.95 7.38 7.38 0 0 1 4.1-1.13c1.28 0 2.47.22 3.56.67a8.8 8.8 0 0 1 4.85 4.91c.48 1.15.72 2.41.72 3.8 0 2.12-.6 4.22-1.78 6.3a25.32 25.32 0 0 1-5.02 6.06 48.77 48.77 0 0 1-7.6 5.62 5.8 5.8 0 0 1-.85.44ZM24 29c1.3 0 2.5-.41 3.48-1.1l1.81 1.8a1 1 0 0 0 1.42-1.4l-1.82-1.82A6 6 0 1 0 24 29Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lifeInsuranceAuditSvg",
    x1: 0,
    y1: 0.26,
    x2: 49.22,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB5D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeInsuranceAudit);
export default __webpack_public_path__ + "static/media/LifeInsuranceAudit.42b27be4db39af1a62c2d897328fac9d.svg";
export { ForwardRef as ReactComponent };